export default "__VITE_ASSET__Cp$qv8Sq__"